import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class CaptionService extends Service {
    constructor() {
        super();
        this.baseURL = 'caption';
    }

    findByAssetId(assetId) {
        return fetch(SERVER_URL + this.baseURL + '/findByAssetId/' + assetId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}

